import { Component } from '@angular/core';
import { ConfirmationModel } from '../../model/confirmation.model';
import { UIActiveDialogService } from '../../services/ui-dialog.service';

@Component({
  selector: '',
  templateUrl:
    '/console/app-js/shared/components/confirmation/confirmation.component.html'
})
export class ConfirmationComponent {
  constructor(
    private confirmationModel: ConfirmationModel,
    public activeDialog: UIActiveDialogService
  ) {}

  protected okButton() {
    this.activeDialog.close(true);
  }

  protected cancelCloseButton(): void {
    this.activeDialog.close(false);
  }
}
